import * as React from 'react'
import { FC } from 'react'

interface ISourcesProps {
  sources?: ISource[]
  className?: string
}

export interface ISource {
  source: string
  link: string
}

const Sources: FC<ISourcesProps> = ({ sources, className }) => {
  if (sources?.length) {
    return (
      <div className={className}>
        <h3>SOURCES</h3>
        {sources.map(({ source, link }, index) => (
          <p className="text--medium" key={index}>
            {source}
            <br />
            <a href={link} target="_blank" rel="noreferrer noopener nofollow">
              {link}
            </a>
          </p>
        ))}
      </div>
    )
  }
  return null
}

export default Sources
